import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SearchPlacementResult } from '../../_models/placement-search/search-placement-result.model';
import { OverviewClientFilters } from '../../_models/session-overview/overview-encrypted-payload.model';

@Injectable({
  providedIn: 'root'
})
export class SessionOverviewHelperService {

  
  private _sessionsChanged: Subject<boolean> = new Subject<boolean>();

  public sessions: Array<SearchPlacementResult> = new Array<SearchPlacementResult>();
  public sessionsFilterHolder: Array<SearchPlacementResult> = new Array<SearchPlacementResult>();
  
  public mobileOverwrite: boolean;

  constructor() { }

  public sessionsChangedWatcher(): Observable<boolean> {
    return this._sessionsChanged;
  }

  public sessionChangedWatchTrigger(): void {
    this._sessionsChanged.next(true)
  }

  /**
   * The filters.session-overview Delivery and Order type filters, applied client-side to the
   * returned placements. Null or empty means no filter; matching ignores case.
   */
  public applyClientFilters(results: Array<SearchPlacementResult>, filters: OverviewClientFilters): Array<SearchPlacementResult> {
    if (!results || !filters) {
      return results;
    }
    const matches = (actual: string, wanted: string) => !wanted || (actual || '').toLowerCase() === wanted.toLowerCase();
    return results.filter(r => matches(r.deliveryMode, filters.deliveryMode) && matches(r.provisionTypeCode, filters.provisionType));
  }

}
